<template>
	<div>
		<span class="font-h4-regular">{{ row[column.key] }}</span>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped></style>
